import React from "react";
import { Box, Typography } from "@mui/material";
import { useNavigate } from "react-router-dom";
import { useTheme } from "@mui/material";
import { tokens } from "../theme";

const ProjectBox = ({ title, date, link, tags = [] }) => {
  const theme = useTheme();
  const colors = tokens(theme.palette.mode);
  const navigate = useNavigate();
  return (
    <Box
      m="20px"
      p="20px"
      sx={{
        border: "1px solid #E0E0E0",
        borderRadius: "16px",
        boxShadow: "0px 4px 12px rgba(0, 0, 0, 0.08)",
        backgroundColor: "colors.primary[100]",  
        transition: "all 0.3s ease-in-out",
        display: "flex",
        flexDirection: "column",
        height: "100%",
        gap: "10px",
        cursor: "pointer",
        "&:hover": {
          transform: "translateY(-5px)",
          boxShadow: "0px 8px 18px rgba(0, 0, 0, 0.12)",
        },
      }}
      onClick={() => {navigate(link)}}
    >
      {/* Job Title */}
      <Typography variant="h5" fontWeight="bold" color={colors.primary[100]}>
        {date} - {title}
      </Typography>

      {tags.length > 0 && (
        <Box mt="10px" display="flex" flexWrap="wrap" gap="8px">
          {tags.map((tag, index) => (
            <Box
              key={index}
              sx={{
                px: "10px",
                py: "4px",
                borderRadius: "12px",
                backgroundColor: colors.primary[100],
                color: colors.primary[900],
                fontSize: "0.8rem",
                fontWeight: "500",
              }}
            >
              {tag}
            </Box>
          ))}
        </Box>
      )}
    </Box>
  );
};

export default ProjectBox;
